// Grids & Gantts — the structure's design tokens. Pure constants, no React.
//
// The same two palettes the rest of the custom surfaces draw with, so a grid
// reads as one of them: neutral page, white card, one dark primary, and the
// semantic colours a structure needs (done, late, warning, links).

export const FONT = '"IBM Plex Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, system-ui, sans-serif';

export const LIGHT = {
  page: '#f6f6f7', card: '#ffffff', fg: '#1c1c1f', muted: '#6c6c76', faint: '#a0a0a8',
  border: '#e8e8eb', surface: '#f3f3f5', primary: '#232327', primaryFg: '#ffffff',
  green: '#16a34a', amber: '#d9930b', red: '#dc2626', blue: '#1868db', grey: '#5e6c84',
  teal: '#0e9f6e', cyan: '#0891b2', purple: '#7c5cd6', rose: '#e0788f', mint: '#5cc9a1', orange: '#f28c28',
  lightBlue: '#5eb3f0', pink: '#f28fb4',
  shadowXs: '0 1px 2px -1px rgba(17,17,26,0.06), 0 1px 1px rgba(17,17,26,0.04)',
  shadowSm: '0 1px 2px -1px rgba(17,17,26,0.06), 0 3px 8px -2px rgba(17,17,26,0.07)',
  shadowMd: '0 4px 8px -3px rgba(17,17,26,0.08), 0 12px 28px -6px rgba(17,17,26,0.14)',
};
export const DARK = {
  page: '#161618', card: '#1f1f23', fg: '#f5f5f7', muted: '#a1a1aa', faint: '#6b6b74',
  border: '#323238', surface: '#26262b', primary: '#e8e8ec', primaryFg: '#1a1a1d',
  green: '#4ade80', amber: '#fbbf24', red: '#f87171', blue: '#60a5fa', grey: '#94a3b8',
  teal: '#34d399', cyan: '#22d3ee', purple: '#a78bfa', rose: '#f4a3b5', mint: '#86efc4', orange: '#fba94c',
  lightBlue: '#7cc4f5', pink: '#f6a8c5',
  shadowXs: '0 1px 2px rgba(0,0,0,0.45)',
  shadowSm: '0 1px 2px rgba(0,0,0,0.45), 0 3px 8px -2px rgba(0,0,0,0.4)',
  shadowMd: '0 4px 12px rgba(0,0,0,0.5), 0 12px 28px -6px rgba(0,0,0,0.55)',
};
